import React, { useState, useEffect } from "react";
import { getRepairDetails } from "../../helpers/articles";
import { ValidateResponse } from "../../helpers/global";
import { Message } from "../../../components/Message";
import { Details } from "../../../components/Details";
import { List } from "../../../components/List";
import { PageTitle } from "../../../components/Page/Title";

export function AppArticlesRepairsDetails({ repairId, identifier, parents }) {

    const [state, setState] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState();

    useEffect(() => {
        getRepairDetails(repairId).then((res) => {

            const response = ValidateResponse(res.data, 'details');

            if (response.status === 'error') {
                setError(response.message, response.status);
            }
            else {

                setState(response.details);
                setIsLoaded(true);
                localStorage.setItem("repair-" + repairId, JSON.stringify(response.details))
            }
        }).catch((error) => {
            const response = ValidateResponse(error);
            setError(response.message);
        });

    }, [repairId]);

    if (error !== undefined) {
        return (<Message type="error" message={error} />);
    }
    if (isLoaded === false) {
        return (<Message type="loading" />);
    }
    if (state === undefined || state === null || Object.keys(state).length === 0) {
        return (<Message type="noData" />);
    }

    let allColums = [
        { key: "repairNumber", label: "Reparatienummer", type: "text" },
        { key: "createDate", label: "Aanmaakdatum", type: "date" },
        { key: "serialNumber", label: "Serienummer", type: "text" },
        { key: "articleName", label: "Artikel", type: "text" },
        { key: "articleCode", label: "Artikelnummer", type: "text" },
        { key: "location", label: "Productlocatie", type: "text" },
        { key: "repairer", label: "Gerepareerd door", type: "text" },
        { key: "statusLabel", label: "Status", type: "text" },
        { key: "repairDate", label: "Reparatiedatum", type: "date" },
        { key: "remarks", label: "Beschrijving defect", type: "text" },
        { key: "actions", label: "Uitgevoerde werkzaamheden", type: "text" },
        { key: "progress", label: "Algemene toelichting", type: "text" },
        { key: "repairNumber", label: "Reparatiebon", type: "download", display: "icon", fileName: "documentName", documentType: "repair" },
    ];

    // Set/remove status-specific fields
    let columns = [];

    allColums.forEach((row) => {

        // Skip fields: hij "pakt" null en "" niet??? daarom null en "" maar --- maken in backend
        if (
            state[row.key] !== undefined
            && state[row.key] !== null
            && state[row.key] !== ""
            && (parents === 'articles/repairs/open' && row.key === 'repairDate') === false
        ) {
            columns.push(row);
        }

    });

    let visitColumns = [
        { key: "visitDate", label: "Bezoekdatum", type: "date", className: "col-2" },
        { key: "startTime", label: "Van", type: "text", className: "col-2" },
        { key: "endTime", label: "Tot", type: "text", className: "col-2" },
        { key: "remark", label: "Opmerkingen", type: "text" },
    ];

    let partColumns = [
        { key: "quantity", label: "Aantal", type: "text", className: "col-1" },
        { key: "statusLabel", label: "Status", type: "text", className: "col-3" },
        { key: "displayName", label: "Onderdeel", type: "text" },
    ];

    return (
        <>
            <Details
                columns={columns}
                data={state}
                identifier="details"
            />

            {state.visits !== undefined && state.visits.length > 0 && (
                <>
                    <PageTitle title="Bezoeken" />
                    <List
                        columns={visitColumns}
                        data={state.visits}
                        identifier="visits"
                    />
                </>
            )}

            {state.parts !== undefined && state.parts.length > 0 && (
                <>
                    <PageTitle title="Gebruikte onderdelen" />
                    <List
                        columns={partColumns}
                        data={state.parts}
                        identifier="parts"
                    />
                </>
            )}

            
        </>
    );
}